import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { ArrowUpRightIcon } from 'lucide-react';
import { MAILTO } from '../../utils/mailto';
export function CTASectionDMRV() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-60px'
  });
  return <section ref={ref} className="w-full py-20 sm:py-28 bg-white" data-id="element-915">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-916">
        <motion.div className="relative overflow-hidden rounded-3xl px-8 py-16 sm:px-16 sm:py-20 text-center" style={{
        background: 'linear-gradient(135deg, #2D6A4F 0%, #1B4332 100%)'
      }} initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-917">
          <div className="absolute -top-20 -right-20 w-64 h-64 rounded-full opacity-10" style={{
          background: 'radial-gradient(circle, #52B788, transparent)'
        }} aria-hidden="true" data-id="element-918" />
          <div className="absolute -bottom-16 -left-16 w-48 h-48 rounded-full opacity-10" style={{
          background: 'radial-gradient(circle, #6BCB77, transparent)'
        }} aria-hidden="true" data-id="element-919" />
          <h2 className="relative text-3xl sm:text-4xl lg:text-5xl font-bold text-white tracking-tight leading-tight max-w-3xl mx-auto" data-id="element-920">
            Every ton measured.
            <br data-id="element-921" />
            <span className="text-carbon-bright" data-id="element-922">Every market trusted.</span>
          </h2>
          <p className="relative mt-5 text-lg text-white/70 max-w-xl mx-auto" data-id="element-923">
            Join producers, exporters, and enterprises using CarbonSafe to
            generate audit-grade climate data and compliance-ready reporting.
          </p>
          <div className="relative mt-10" data-id="element-924">
            <a href={MAILTO.demo} className="inline-flex items-center gap-2.5 px-8 py-4 bg-carbon-bright text-white text-base font-semibold rounded-lg hover:bg-carbon-light transition-colors shadow-lg shadow-black/20" data-id="element-925">
              Book Demo
              <ArrowUpRightIcon className="w-4.5 h-4.5" data-id="element-926" />
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}